import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/card/card.jsx";
import TableBody from "../../../components/table/TableBody.jsx";

function Users() {
	const navigate = useNavigate();

	const handleAddUser = (send) => {
		navigate("/customersDetails", { state: send });
	};

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Clientes</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => handleAddUser({ type: "add" })} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar Cliente
					</button>
				</div>
			</div>

			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<TableBody table={"customers"} />
					</div>
				</div>
			</Card>
		</div>
	);
}

export default Users;
